import { MicroappVmsVisit } from './microapp-vms-visit.model';
import { MatTableDataSource } from '@angular/material/table';
import { MicroappVmsVisitorWithPendingVisits } from './microapp-vms-visitor-pending-visits.model';

export class MicroappVmsVisitorAddressBook{
    visitor: MicroappVmsVisitorWithPendingVisits;
    dataSource: MatTableDataSource<MicroappVmsVisit>;
}